import React from 'react';
import { toast } from 'react-toastify';
import { ReactComponent as AlertNotificationIcon } from '../assets/svg/notificationsIcons/alert.svg';
import { ReactComponent as SuccessNotificationIcon } from '../assets/svg/notificationsIcons/check.svg';
import { ReactComponent as ErrorNotificationIcon } from '../assets/svg/notificationsIcons/error.svg';
import { useConfirmModalStore } from '../stores/confirmModalStore';

const DEFAULT_TOAST_OPTIONS = {
  autoClose: 3000,
};

const ToastBody = ({ title, message, children }) => (
  <div className="rambla-toast-body">
    {title ? <div className="rambla-toast-title">{title}</div> : null}
    {message ? <div className="rambla-toast-message">{message}</div> : null}
    {children}
  </div>
);

const showToast = (type, title, message, options = {}) => {
  const { component, icon, ...restOptions } = options;
  const content = (
    <ToastBody title={title} message={message}>
      {component}
    </ToastBody>
  );

  toast[type](content, {
    ...DEFAULT_TOAST_OPTIONS,
    icon,
    ...restOptions,
  });
};

export const toastr = {
  success: (title, message, options) => {
    showToast('success', title, message, {
      icon: <SuccessNotificationIcon />,
      ...options,
    });
  },
  warning: (title, message, options) => {
    showToast('warning', title, message, {
      icon: <AlertNotificationIcon />,
      ...options,
    });
  },
  error: (title, message, options) => {
    showToast('error', title, message, {
      icon: <ErrorNotificationIcon />,
      ...options,
    });
  },
  info: (title, message, options) => {
    showToast('info', title, message, options);
  },
  confirm: (
    heading,
    { onClose, description, onOk, submitLabel, closeLabel, cancelText, okText },
  ) => {
    useConfirmModalStore.getState().openConfirmModal({
      heading,
      description,
      closeLabel: cancelText || closeLabel,
      okLabel: okText || submitLabel,
      onOk,
      onClose,
    });
  },
};
